module.exports = __webpack_public_path__ + "static/d6-5a84918d05e9567096c06a90ef14fe4f.jpg";